import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  LoginByOtpOneCredentialOptionalFlowEventDefinition,
  LoginByOtpOneCredentialOptionalFlowEventState,
} from './types';

export function useLoginByOtpOneCredentialOptionalFlowEvent() {
  return usePageEventContext<
    LoginByOtpOneCredentialOptionalFlowEventDefinition
  >();
}

export function withLoginByOtpOneCredentialOptionalFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    LoginByOtpOneCredentialOptionalFlowEventDefinition,
    LoginByOtpOneCredentialOptionalFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
